import { createFileRoute } from "@tanstack/react-router";

import { ContactPageContent } from "@/components/site/ContactPageContent";
import { SiteShell } from "@/components/site/SiteShell";
import { business } from "@/lib/business";
import { localBusinessJsonLd, pageHead } from "@/lib/seo";

const title = `Contact | ${business.name} — ${business.city}, ${business.state}`;
const description = `Call ${business.phone} for engine machine work in ${business.city}, ${business.state}. ${business.hours}. ${business.address}. Request boring, sleeving, line boring, or surfacing — we return calls within 24 hours.`;

export const Route = createFileRoute("/contact")({
  validateSearch: (search: Record<string, unknown>): { sent?: true; error?: true } => {
    const sent = search["sent"] === "1" || search["sent"] === 1;
    const error = search["error"] === "1" || search["error"] === 1;
    return {
      ...(sent ? { sent: true } : {}),
      ...(error ? { error: true } : {}),
    };
  },
  component: ContactPage,
  head: () => ({
    ...pageHead({ title, description, path: "/contact" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(localBusinessJsonLd(description)),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: title,
          description,
          url: `${business.siteUrl}/contact`,
          mainEntity: {
            "@type": "AutoMachineShop",
            name: business.name,
            telephone: business.phone,
            email: business.email,
            address: {
              "@type": "PostalAddress",
              streetAddress: business.address,
              addressLocality: business.city,
              addressRegion: business.state,
              postalCode: business.zip,
              addressCountry: "US",
            },
            openingHours: "Mo-Fr 08:00-17:00",
          },
        }),
      },
    ],
  }),
});

function ContactPage() {
  const { sent, error } = Route.useSearch();

  return (
    <SiteShell>
      <ContactPageContent initialStatus={sent ? "sent" : error ? "error" : undefined} />
    </SiteShell>
  );
}
